import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  font-family: Arial, sans-serif;
`;

export const Title = styled.h1`
  margin-left: 10px;
  color: #333;
  margin-bottom: 30px;
  font-weight: bold;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const Card = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 15px 15px;
  min-width: 320px;
  background-color: #f9f9f9;
  margin-top: -15px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
`;

export const CardText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #555;

  &:first-child {
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 16px;
  }
`;

export const DebtTotal = styled.span`
  color: #d32f2f;
`;

export const SectionTitle = styled.h3`
  margin: 20px 0 8px;
  font-size: 15px;
  color: #333;

  &:first-child {
    margin-top: 0;
  }
`;

export const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }
`;

export const StatusLabel = styled.span`
  color: #555;
`;

export const StatusBadge = styled.span<{ alert?: boolean }>`
  font-size: 12px;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 12px;
  color: #fff;
  background-color: ${({ alert }) => (alert ? "#d32f2f" : "#2e7d32")};
`;

export const ScoreBox = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 6px;
`;

export const ScoreValue = styled.span`
  font-size: 28px;
  font-weight: bold;
  color: #333;
`;

export const ScoreRisk = styled.span`
  font-size: 13px;
  color: #777;
`;

export const ScoreDescription = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  color: #666;
`;

export const OcorrenciaResumoText = styled.p`
  margin: -2px 0 6px;
  font-size: 12px;
  color: #d32f2f;
  text-align: right;
`;
